// common graphing functions
import { updateDataArea, updateTableArea, populateATFilters, updateFilters, updatePrimarySelector, filterByAT, generateCountryAbstract, arrayUnique, updateRataArea } from './graphing-functions';
import { fetchJSON } from './search-functions';

// Get publication data
let publicationData = fetchJSON('https://opensheet.elk.sh/1UASpyY5jUr3ba_l0uBlC-h8D3dACMXj0Nk66IBId8hw/articles');
let pubCountries: any

publicationData.then(data => {
  pubCountries = [... new Set(data.map(country => country.Country))]
  publicationData = data;
  checkCanRun();
})

// Cohort Data
let cohortData = fetchJSON('https://opensheet.elk.sh/1UASpyY5jUr3ba_l0uBlC-h8D3dACMXj0Nk66IBId8hw/cohorts');
let cohortCountries: any

cohortData.then(data => {
  cohortCountries = [... new Set(data.map(country => country.Country))]
  cohortData = data;
  checkCanRun();
})


// Survey data
let surveyData = fetchJSON('https://opensheet.elk.sh/1UASpyY5jUr3ba_l0uBlC-h8D3dACMXj0Nk66IBId8hw/surveys');
let surveyCountries: any

surveyData.then(data => {
  surveyCountries = [... new Set(data.map(country => country.Country))]
  surveyData = data;
  checkCanRun();
})

let rataData = fetchJSON('https://opensheet.elk.sh/1UASpyY5jUr3ba_l0uBlC-h8D3dACMXj0Nk66IBId8hw/rata');
let rataCountries: any

rataData.then(data => {
  rataCountries = [... new Set(data.map(country => country.Country))]
  rataData = data;
  checkCanRun();
})


function checkCanRun() {
  if (surveyCountries && cohortCountries && pubCountries && rataCountries) {
    runPage();
  }
}

/*  --------------------- Runtime ---------------------- */


function runPage() {
  // Combine all country sets and de dupe, add a 'super' option of Global to the array to show all. 
  const countries = arrayUnique(pubCountries.concat(cohortCountries).concat(surveyCountries).concat(rataCountries));
  countries.push("Global");
  countries.sort();

  const publicationsByCountry = countries.map(publication => {
    return { name: publication, data: publicationData.filter(datum => datum.Country === publication) }
  })

  const cohortsByCountry = countries.map(cohort => {
    return { name: cohort, data: cohortData.filter(datum => datum.Country === cohort) }
  })

  const surveysByCountry = countries.map(survey => {
    return { name: survey, data: surveyData.filter(datum => datum.Country === survey) }
  })

  const rataByCountry = countries.map(rata => {
    return { name: rata, data: rataData.filter(datum => datum.Country === rata) }
  })

  // Constants for dropdown and display areas
  const publicationDataArea: HTMLDivElement = document.getElementById('js-publication-container');
  const surveyDataArea: HTMLDivElement = document.getElementById('js-survey-container');
  const cohortDataArea: HTMLDivElement = document.getElementById('js-cohort-container');
  const rataDataArea: HTMLDivElement = document.getElementById('js-rata-container');
  const select: HTMLSelectElement = document.getElementById('js-country-select');
  const filter: HTMLSelectElement = document.getElementById('js-at-select');
  const clearFilters: HTMLButtonElement = document.getElementById('js-clear-filters');
  const abstract: HTMLSpanElement = document.getElementById('js-abstract');
  const rataPanel: HTMLButtonElement = document.getElementsByClassName('js-rata-panel')[0];

  // Constant for query string country
  const urlParams = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let initialCountry = urlParams.country;


  // Global access to the in-use data set.
  var activePubData: any
  var activeCohortData: any
  var activeSurveyData: any
  var activeRataData: any

  // Populate Dropdown
  for (var i = 0; i < countries.length; i++) {
    var option = document.createElement("option");
    var currentCountry = countries[i];
    if (currentCountry) {
      option.text = currentCountry;
      option.value = currentCountry;
      select?.add(option);
    }
  }

  // When the user changes the country
  select?.addEventListener('change', () => {
    let country = select?.value;
    let filterValue = filter?.value;
    activePubData = updatePrimarySelector(country, publicationsByCountry);
    activeCohortData = updatePrimarySelector(country, cohortsByCountry);
    activeSurveyData = updatePrimarySelector(country, surveysByCountry);
    activeRataData = updatePrimarySelector(country, rataByCountry);
    updateFilters(activePubData, filter, "at");
    updateDataArea(publicationDataArea, activePubData);
    updateTableArea(surveyDataArea, activeSurveyData);
    updateTableArea(cohortDataArea, activeCohortData);
    updateRataArea(rataDataArea, activeRataData, country);
    generateCountryAbstract(activePubData, abstract, country, activeCohortData, activeRataData, activeSurveyData);

    // If the country is no longer global, then re-show the rata panel
    if (country !== "Global") {
      rataPanel.style.display = "inline";
    }

    // If AT filter was selected, get the value, compare it to the available AT filters on the new country, and display, or show error modal.
    if (filterValue) {
      let currentATTypes = [... new Set(activePubData.map(atType => atType['AP Type']))];

      if (currentATTypes.includes(filterValue)) {
        // Do same action as the filter
        let filteredData = filterByAT(filterValue, activePubData);

        if (filteredData && publicationDataArea) {
          updateDataArea(publicationDataArea, filteredData);
          generateCountryAbstract(filteredData, abstract, country, null, null, null, filterValue);
          filter.value = filterValue;
        }

        // Initialise the clear filters button
        if (!clearFilters.classList.contains('active')) {
          clearFilters.classList.add('active')
        }
      } else {
        // If the AT is not on the selected country, then show an error modal.
        document.getElementById("puberrormodal")?.showModal();
        clearFilters.classList.remove('active')
      }
    }
  });

  // When the user filters the list 
  filter?.addEventListener('change', () => {
    let atType = filter?.value;
    let filteredData = filterByAT(atType, activePubData);
    let country = select?.value;

    if (filteredData && publicationDataArea) {
      updateDataArea(publicationDataArea, filteredData);
      generateCountryAbstract(filteredData, abstract, country, null, null, null, atType);
    }

    // Initialise the clear filters button
    if (!clearFilters.classList.contains('active')) {
      clearFilters.classList.add('active')
    }
  });

  // when a user clears the list 
  clearFilters?.addEventListener('click', () => {
    filter.selectedIndex = 0;
    let country = select?.value;
    activePubData = updatePrimarySelector(country, publicationsByCountry);

    if (activePubData && publicationDataArea) {
      updateDataArea(publicationDataArea, activePubData);
      generateCountryAbstract(activePubData, abstract, country, activeCohortData, activeRataData, activeSurveyData);
      clearFilters.classList.remove('active')
    } else {
      clearFilters.innerText = "Something's gone wrong, please reload"
    }
  })

  // When a user changes tabs
  document.addEventListener("tabs-changed", function (e) {
    filter.selectedIndex = 0;
    let country = select?.value;
    activePubData = updatePrimarySelector(country, publicationsByCountry);

    if (activePubData && publicationDataArea) {
      updateDataArea(publicationDataArea, activePubData);
      generateCountryAbstract(activePubData, abstract, country, activeCohortData, activeRataData, activeSurveyData);
      clearFilters.classList.remove('active')
    } else {
      clearFilters.innerText = "Something's gone wrong, please reload"
    }
  });


  //Initial population
  if (publicationDataArea) {
    if (initialCountry && countries.includes(initialCountry)) {
      var country = initialCountry
      select.value = initialCountry
    } else {
      var country = "Global";
      select.value = "Global";
      rataPanel.style.display = "none";
    }
    let initialPubData = updatePrimarySelector(country, publicationsByCountry)
    let initialCohortData = updatePrimarySelector(country, cohortsByCountry);
    let initialSurveyData = updatePrimarySelector(country, surveysByCountry);
    let initialRataData = updatePrimarySelector(country, rataByCountry);

    populateATFilters(initialPubData, filter);
    updateDataArea(publicationDataArea, initialPubData);
    updateTableArea(surveyDataArea, initialSurveyData);
    updateTableArea(cohortDataArea, initialCohortData);
    updateRataArea(rataDataArea, initialRataData, country);
    generateCountryAbstract(initialPubData, abstract, country, initialCohortData, initialRataData, initialSurveyData);

    activePubData = initialPubData;
    activeCohortData = initialCohortData;
    activeSurveyData = initialSurveyData;
    activeRataData = initialRataData;
  }
}
